import React, { Component } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { Button, Nav, Navbar, NavLink, NavbarBrand, UncontrolledAlert } from 'reactstrap';
import Api from '../Api';
import AdminDD from './Admin';
import ContractDD from './Contract';
import CreditDD from './Credit';
import EntitiesDD from './Entities';
import ExportDD from './Export';
import ItemDD from './Items';
import OperationsHeader from './Operations';
import QaDD from './Qa';
import StorageToken from '../StorageToken';
export default class Header extends Component {
  constructor(props) {
    super(props);
    this.getNavBarClass = () => {
      let css = '';
      if (this.props.app_env === 'production') {
        css = 'navbar-light bg-light box-shadow border-bottom';
      } else {
        css = 'navbar-dark bg-dark';
      }
      return css;
    };
    this.getTitleText = () => {
      let text = 'Otto EU';
      if (this.props.app_env !== 'production') {
        text += " Non-Prod ( ".concat(this.props.app_env, " environment )");
      }
      return text;
    };
    this.getRefreshMsg = () => {
      let msg = '';
      if (window.location.href.includes('expired=Y')) {
        msg = /*#__PURE__*/React.createElement(UncontrolledAlert, {
          color: "info",
          className: "text-center"
        }, "This page was refreshed because your login expired.");
      }
      return msg;
    };
    this.logout = async e => {
      e.preventDefault();
      window.localStorage.removeItem('okta-cache-storage');
      window.localStorage.removeItem('okta-token-storage');
      window.localStorage.removeItem('okta-group-storage');
      window.localStorage.removeItem(StorageToken.get());
      window.location = 'https://westernmilling.okta.com/login/signout';
    };
    this.toggle = () => this.setState(prevState => ({
      isOpen: !prevState.isOpen
    }));
    this.usersModules = () => (this.props.userInfo || {}).modules || [];
    this.showModule = moduleName => this.usersModules().includes(moduleName);
    this.dropdowns = () => /*#__PURE__*/React.createElement(Nav, null, /*#__PURE__*/React.createElement(OperationsHeader, {
      userModules: this.usersModules,
      env: this.props.app_env
    }), this.showModule('qa') ? /*#__PURE__*/React.createElement(QaDD, null) : '', this.showModule('contracts') ? /*#__PURE__*/React.createElement(ContractDD, null) : '', this.showModule('items') ? /*#__PURE__*/React.createElement(ItemDD, null) : '', this.showModule('credit') ? /*#__PURE__*/React.createElement(CreditDD, null) : '', this.showModule('entities') ? /*#__PURE__*/React.createElement(EntitiesDD, null) : '', this.showModule('exports') ? /*#__PURE__*/React.createElement(ExportDD, null) : '', this.showModule('admin') || this.showModule('elian_admin') ? /*#__PURE__*/React.createElement(AdminDD, {
      userModules: this.usersModules
    }) : '', /*#__PURE__*/React.createElement(NavLink, {
      href: "#",
      onClick: this.logout
    }, "logout \xA0", this.props.name));
    this.clearApiHost = () => {
      Api.clearApiHost();
      window.location.reload(true);
    };
    this.state = {
      isOpen: true
    };
  }
  render() {
    const ottoLink = "".concat(process.env.REACT_APP_BASE_URL, "/");
    return /*#__PURE__*/React.createElement("div", {
      id: "otto_header"
    }, /*#__PURE__*/React.createElement(Navbar, {
      className: this.getNavBarClass()
    }, /*#__PURE__*/React.createElement(NavbarBrand, {
      href: ottoLink
    }, this.getTitleText()), Api.localStorageHost() ? /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("small", {
      className: "otto__margin_right",
      style: {
        color: '#fff'
      }
    }, "Host:", Api.localStorageHost()), /*#__PURE__*/React.createElement(Button, {
      color: "secondary",
      size: "sm",
      onClick: this.clearApiHost
    }, "clear")) : '', this.dropdowns()), this.getRefreshMsg(), /*#__PURE__*/React.createElement("br", null));
  }
}